import axios from "axios";
import { Message } from "element-ui";
const http = axios.create({
  //通用请求地址前缀
  baseURL: "/apiMain",
  // baseURL: "https://api.dygyl666.com/Main/action", //正式
  // baseURL: "http://fuzhuan.cc/Main/action", //测式
  timeout: 10000, //超时时间
});

// 添加请求拦截器
http.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return {
      ...config,
      headers: {
        "Content-Type":
          config.method == "post" ? "multipart/form-data" : "application/json",
        Authorization: localStorage.getItem("token"),
      },
    };
  },
  function (error) {
    // 对请求错误做些什么
    Message({
      message: JSON.stringify(error),
      type: "error",
    });
    return Promise.reject(error);
  }
);

// 添加响应拦截器
http.interceptors.response.use(
  function (response) {
    const { code, msg } = response.data;
    if(code !== 200){
      Message({
        message: msg,
        type: "error",
      });
    }
    // 对响应数据做点什么
    return response.data;
  },
  function (error) {
    Message({
      message: JSON.stringify(error),
      type: "error",
    });
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default http;
